module.exports = __webpack_public_path__ + "img/tietle1.aeabec21.png";